/**
 * Light, Dark or System, chosen on Your settings. Copied from studio-fripp:
 * the choice lives in this browser's localStorage, keyed by the signed-in
 * person's email, and is never sent to the server, so it does not follow a
 * person between devices.
 *
 * The inline script in `apps/ui/index.html` repeats these keys and this
 * resolution so the theme is set before the app's module runs.
 * `appearance.test.ts` runs that script against `resolveTheme`; change both
 * together.
 */

export type AppearanceChoice = 'light' | 'dark' | 'system';
export type Theme = 'light' | 'dark';

export const APPEARANCE_CHOICES: readonly AppearanceChoice[] = ['light', 'dark', 'system'];
export const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';

/**
 * The person whose choice the inline script applies on load. It is forgotten
 * when they sign out, so the sign-in screen is never themed for anyone.
 */
export const LAST_USER_KEY = 'ops.appearance.lastUser';

export function appearanceKey(userId: string): string {
  return `ops.appearance.user.${userId}`;
}

export function parseChoice(raw: string | null): AppearanceChoice {
  return raw === 'light' || raw === 'dark' ? raw : 'system';
}

export function resolveTheme(choice: AppearanceChoice, prefersDark: boolean): Theme {
  if (choice === 'system') return prefersDark ? 'dark' : 'light';
  return choice;
}
